<template>
  <div class="layout-pods">
    <header class="layout-pods-header pg-header">
      <form id="client-search" class="search-form campaigns-client-search">
        <input
          class="form-control"
          type="search"
          placeholder="Search"
          aria-label="Search"
          v-model="searchText"
        />
      </form>
      <button
        class="btn btn-primary"
        @click.prevent="openModal(null)"
        v-if="currentTabName !== 'Archived' && canAddClient()"
      >
        Add Client
      </button>
    </header>
    <div class="pods-container">
      <section class="notifications-list">
        <template>
          <ol v-if="clients.length > 0">
            <li>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-2"></div>
                  <div class="col-2">
                    <b>Client</b>
                  </div>
                  <div class="col-2">
                    <b>Product</b>
                  </div>
                  <div class="col-2">
                    <b>Payment Method - Vendor</b>
                  </div>
                  <div class="col-2">
                    <b>Payment Method - Agent</b>
                  </div>
                  <div class="col-2">
                    <b>Payment Method - Office</b>
                  </div>
                </div>
              </div>
            </li>
            <li v-for="client in clients" :key="client.id">
              <div class="container-fluid">
                <div class="row" style="padding:10px">
                  <div class="col-2">
                    <div class="logo">
                      <img :src="getLogo(client)" class="checkboard-bg" />
                    </div>
                  </div>
                  <div class="col-2 vertical-align-middle">
                    <p>
                      <a href="#" @click.prevent="openModal(client)">{{
                        client.title
                      }}</a>
                    </p>
                  </div>
                  <div class="col-2 vertical-align-middle">
                    <p>{{ client.product }}</p>
                  </div>
                  <div class="col-2 vertical-align-middle">
                    <p
                      v-if="
                        client.propertyCampaignPaymentOption == 'credit-card'
                      "
                    >
                      Credit Card
                    </p>
                    <p
                      v-if="
                        client.propertyCampaignPaymentOption == 'trading-terms'
                      "
                    >
                      Trading Terms
                    </p>
                  </div>
                  <div class="col-2 vertical-align-middle">
                    <p
                      v-if="client.agentCampaignPaymentOption === 'credit-card'"
                    >
                      Credit Card
                    </p>
                    <p
                      v-if="
                        client.agentCampaignPaymentOption === 'trading-terms'
                      "
                    >
                      Trading Terms
                    </p>
                  </div>
                  <div class="col-2 vertical-align-middle">
                    <p
                      v-if="
                        client.officeCampaignPaymentOption === 'credit-card'
                      "
                    >
                      Credit Card
                    </p>
                    <p
                      v-if="
                        client.officeCampaignPaymentOption === 'trading-terms'
                      "
                    >
                      Trading Terms
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ol>
        </template>
      </section>
    </div>
    <div class="col-12 mt-4" v-if="clients.length > 0 && hasMorePages">
      <div class="btn-container" style="text-align: center">
        <button class="btn-primary btn" @click="currentCursor = nextCursor">
          Load more
        </button>
      </div>
    </div>
    <transition name="modal">
      <client-modal
        v-if="showModal"
        :client-id="clientId"
        @closeModal="closeModal"
      ></client-modal>
    </transition>
  </div>
</template>

<script>
import ClientModal from './ClientModal';
import ClientServices from '../../services/clients';
import ClientPerimeters from '../../configs/Perimeters/clients';
import {refreshPageMixin} from '../../mixins/refreshPage';
import {FilterBuilder} from '../../helpers/FilterBuilder';
import ApiCallMixin from '../../mixins/ApiCallMixin';

const GET_CLIENTS_KEY = 'GET_CLIENTS';

export default {
  mixins: [refreshPageMixin, ApiCallMixin],
  perimeters: [ClientPerimeters],
  components: {
    ClientModal,
  },
  data() {
    return {
      currentTabName: 'My Clients',
      showModal: false,
      clientId: false,
      clients: [],
      searchText: '',
      currentCursor: 0,
      nextCursor: 0,
      hasMorePages: false,
      filterBuilder: new FilterBuilder(),
    };
  },
  methods: {
    getLogo(client) {
      if (client.clientDisplayConfig && client.clientDisplayConfig.imageLogo) {
        return (
          process.env.VUE_APP_CDN_URL +
          client.clientDisplayConfig.imageLogo.location
        );
      }
      return 'data:image/png;base64,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';
    },
    canAddClient() {
      return ClientPerimeters.isAllowed('add');
    },
    closeModal() {
      this.showModal = false;
      this.clientId = null;
    },
    openModal(client) {
      if (client && client.status !== 'archived') {
        this.showModal = true;
        this.clientId = client.id;
      } else if (client === null) {
        this.showModal = true;
      }
    },
    changeTab(tab) {
      this.currentTabName = tab.name;
      if (tab.name === 'Archived') {
        this.getClients('archived');
        return;
      }
      this.getClients('published');
    },
    unArchive(client) {
      client.status = 'published';
      ClientServices.updateClient(client)
        .then((client) => {
          this.getClients('published');
          this.$refs.tabs.changeTab({name: 'My Offices'});
        })
        .catch((errors) => {
          this.errors = errors;
        });
    },
    async getClients(status) {
      const response = await this.request(
        GET_CLIENTS_KEY,
        ClientServices.getClients,
        status,
        'agencies,clientIntegration,billingAddress,client, clientDisplayConfig',
        10,
        this.currentCursor,
        this.filterBuilder.get()
      );

      const hasNext = response.meta.cursor.hasOwnProperty('next');
      this.hasMorePages = hasNext;
      if (hasNext) {
        this.nextCursor = response.meta.cursor.next.cursor;
      }
      response.data.forEach((client) => {
        ClientServices.getClientDisplayConfig(client.id, 'imageLogo').then(
          (clientDisplayConfig) => {
            this.$set(client, 'clientDisplayConfig', clientDisplayConfig);
          }
        );
      });

      this.clients =
        this.currentCursor === 0
          ? response.data
          : [...this.clients, ...response.data];

      //   .then((response) => {
      //     const hasNext = response.meta.cursor.hasOwnProperty('next');
      //     this.hasMorePages = hasNext;
      //     if (hasNext) {
      //       this.nextCursor = response.meta.cursor.next.cursor;
      //     }
      //     response.data.forEach((client) => {
      //       ClientServices.getClientDisplayConfig(client.id, 'imageLogo').then(
      //         (clientDisplayConfig) => {
      //           this.$set(client, 'clientDisplayConfig', clientDisplayConfig);
      //         }
      //       );
      //     });

      //     this.clients =
      //       this.currentCursor === 0
      //         ? response.data
      //         : [...this.clients, ...response.data];
      //   });
    },
    checkPermission() {
      ClientPerimeters.isAllowed('view')
        ? this.getClients('published')
        : this.$router.push('/offices');
    },
  },
  watch: {
    hashChanged(newVal) {
      if (newVal) {
        this.checkPermission();
      }
    },
    currentCursor: {
      handler(value) {
        if (value === 0) return;

        this.getClients('published');
      },
    },
    searchText: {
      handler: function(value) {
        clearTimeout(this.searchTimeout);

        if (!value.length) {
          this.filterBuilder.removeFilter('searchText');
        } else {
          this.filterBuilder.addFilter('searchText', value);
        }

        this.searchTimeout = setTimeout(() => {
          this.currentCursor = 0;
          this.getClients('published');
        }, 1000);
      },
    },
  },
  mounted() {
    this.checkPermission();
  },
};
</script>

<style lang="css">
.logo img {
    width: 50%;
    height: auto;
}
.vertical-align-middle {
    display: flex;
    align-items: center;
}
</style>
